import { PEOPLE_TYPES } from './../../../store/features/realtime/presence/types';
export var ChildReducerName;
(function (ChildReducerName) {
    ChildReducerName["toasts"] = "toasts";
    ChildReducerName["loading"] = "loading";
    ChildReducerName["error"] = "error";
    ChildReducerName["modal"] = "modal";
    ChildReducerName["general"] = "general";
})(ChildReducerName || (ChildReducerName = {}));
export var ApiCallState;
(function (ApiCallState) {
    ApiCallState["request"] = "REQUEST";
    ApiCallState["success"] = "SUCCESS";
    ApiCallState["error"] = "ERROR";
})(ApiCallState || (ApiCallState = {}));
export const SERVER_ERROR_ACTION_NAME = 'general-server';
export const BASE64_PREFIX = 'data:image/png;base64,';
export const DATA_URL_IMAGE_PREFIX = 'data:image/';
export var UserRole;
(function (UserRole) {
    UserRole["Patient"] = "patient";
    UserRole["Doctor"] = "doctor";
})(UserRole || (UserRole = {}));
export const PeopleTypeToUserRoleMap = {
    [PEOPLE_TYPES.doctor]: UserRole.Doctor,
    [PEOPLE_TYPES.patient]: UserRole.Patient,
};
export var UserType;
(function (UserType) {
    UserType["Patient"] = "patient";
    UserType["Provider"] = "provider";
    UserType["Member"] = "member";
    UserType["Admin"] = "admin";
    UserType["Owner"] = "owner";
})(UserType || (UserType = {}));
export var UserSubscriptionType;
(function (UserSubscriptionType) {
    UserSubscriptionType["Clinic"] = "clinic";
    UserSubscriptionType["Pro"] = "pro";
    UserSubscriptionType["Free"] = "free";
    UserSubscriptionType["Trial"] = "trial";
})(UserSubscriptionType || (UserSubscriptionType = {}));
export var PlanNames;
(function (PlanNames) {
    PlanNames["pro"] = "Professional";
    PlanNames["clinic"] = "Clinic";
    PlanNames["free"] = "Free";
})(PlanNames || (PlanNames = {}));
export var PlanTypes;
(function (PlanTypes) {
    PlanTypes["Professional"] = "professional";
    PlanTypes["Clinic"] = "clinic";
    PlanTypes["Free"] = "free";
})(PlanTypes || (PlanTypes = {}));
export const SubscriptionSteps = {
    Entry: 'entry',
    CreditCard: 'credit-card',
    Congratulation: 'congratulation',
};
